<h2 mat-dialog-title>{{ 'SelectAGoalPlan' | translate: {Default: "Select A Goal Plan"} }}</h2>

<mat-dialog-content>
    <div *ngIf="selectedGoal" class="selected-goal page-description-section">
        <h6>{{ 'SelectedGoalPlan' | translate: {Default: "Selected Goal Plan"} }}: {{selectedGoal.name}}</h6>
    </div>

    <app-local-data-grid-comp
        class="data-grid"
        [columns]="columns"
        [data]="goalPlans"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [pageable]="false"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectRowBy: 'id',
            showDeleteAllButton: false,
            selectableMode: 'single'
        }"
        category=""
        (emitSelectedRows)="selectedRowsChanged($event)"
    ></app-local-data-grid-comp>
    
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!selectedGoal">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>